var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 496 496",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "119.178,72.985 0,423.015 60.237,423.015 146.667,72.985  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.822,72.985 349.333,72.985 435.763,423.015 496,423.015  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.176,72.985L83.93,423.015h127.624l3.514-51.512h65.864l3.514,51.512H412.07L325.827,72.985H170.176z M236.651,76.998 h22.699l3.596,49.085h-29.893L236.651,76.998z M229.458,175.167h37.086l3.597,49.084h-44.283L229.458,175.167z M218.667,322.417 l3.596-49.082h51.475l3.599,49.082H218.667z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoad);
export default __webpack_public_path__ + "static/media/road.815c1fde268e4140a516f1201c01b4bc.svg";
export { ForwardRef as ReactComponent };